<template>
  <span>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true" :class="[svgClassName, 'select-none']">
      <title>Brzi pregled</title>
      <path d="M228.24,219.76l-51.38-51.38a86.15,86.15,0,1,0-8.48,8.48l51.38,51.38a6,6,0,0,0,8.48-8.48ZM38,112a74,74,0,1,1,74,74A74.09,74.09,0,0,1,38,112Z"></path>
    </svg>
  </span>
</template>

<script>
export default {
  name: "MagnifyIcon",
  props: {
    svgClassName: {
      type: String,
      default: ""
    }
  }
};
</script>